import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import ModalWrapper from 'app/commonComponents/modal/modalWrapper';
import PropTypes from 'prop-types';
import InteractiveSizeGuide from '../interactiveSizeGuide/interactiveSizeGuide';
import ShoeSizeGuide from '../shoeSizeGuide/shoeSizeGuide';
import './interactive-size-guide-modal.scss';

class SizeGuide extends Component {
  constructor() {
    super();

    this.state = {
      isModalOpen: false,
    };

    this.toggleModal = this.toggleModal.bind(this);
  }

  toggleModal() {
    this.setState(prevState => ({
      isModalOpen: !prevState.isModalOpen,
    }));
  }

  render() {
    const { isModalOpen } = this.state;
    const { gender, silhouette, isLeisurewearProduct, shoeSizeGuideType, intl } = this.props;
    const hasSizeGuide = isLeisurewearProduct || Boolean(shoeSizeGuideType);

    return (
      <div className={`pdp__size-guide ${!hasSizeGuide ? '_is-disabled' : ''}`}>
        <button
          aria-label={intl.formatMessage({
            id: 'products.pdp.sizeGuide.sizeGuide',
          })}
          type="button"
          className="pdp__size-guide-wrapper-link js-tracking-size-guide"
          onClick={() => this.toggleModal()}
        >
          <span className="pdp__size-guide-label">
            <FormattedMessage id="products.pdp.sizeGuide.sizeGuide" />
          </span>
          <br />
        </button>
        {isLeisurewearProduct ? (
          <ModalWrapper
            customParentClass="interactive-size-guide-modal"
            maxWidth={800}
            isModalOpen={isModalOpen}
            modalToggle={this.toggleModal}
            isWithinSticky
          >
            <InteractiveSizeGuide gender={gender} silhouette={silhouette} />
          </ModalWrapper>
        ) : (
          shoeSizeGuideType && (
            <ModalWrapper
              customParentClass="size-guide-modal"
              maxWidth={800}
              isModalOpen={isModalOpen}
              modalToggle={this.toggleModal}
              isWithinSticky
            >
              <ShoeSizeGuide type={shoeSizeGuideType} />
            </ModalWrapper>
          )
        )}
      </div>
    );
  }
}

SizeGuide.defaultProps = {
  shoeSizeGuideType: null,
};

SizeGuide.propTypes = {
  gender: PropTypes.object.isRequired,
  silhouette: PropTypes.object.isRequired,
  isLeisurewearProduct: PropTypes.bool.isRequired,
  shoeSizeGuideType: PropTypes.string,
};

export default injectIntl(SizeGuide);
